import { GameActionBtn } from "./GameCompsF.jsx"

export const DebugUpdateGameStateBtn = () => {
  return <GameActionBtn {...{bg: 'orange', my: 5, actionH: {playerAction: 'debugUpdateGameState'}}}>
    {/* manual glitch fix to debug when happens instead of ss setInterval */}
    Bump Game State
  </GameActionBtn>
}

export const HardResetGameBtn = () => {
  return <GameActionBtn {...{reqConfirmStr: 'confirm', my: 5, bg: 'tomato', actionH: {playerAction: 'resetGame'}}}>
    Reset Game
  </GameActionBtn>
}

export const LeaveGameBtn = () => {
  return <GameActionBtn {...{'data-testid': 'leave-game-btn', reqConfirmStr: `Are you sure? You're done playing?`, bg: 'orange', my: 5, actionH: {playerAction: 'leaveGame'}}}>
    Leave Game
  </GameActionBtn>
}